export const WORK_FLOW_TYPE = {
    GLOBAL_CASE: "globalCase",
    GLOBAL_CHECKS: "globalCheck",
    CASE: "CASE",
    CHECKS: "CHECKS",
}

export const SLA_OPTIONS = {
    "duration_type": [{
        id: "days",
    }, {
        id: "hours",
    }],
    "timezones": [{
        id: "utc",
    }, {
        id: "gmt",
    }, {
        id: "ist",
    }, {
        id: "est",
    }, {
        id: "cst",
    }, {
        id: "jst",
    }],
    "time": ["00:00", "00:30", "01:00", "01:30", "02:00", "02:30", "03:00", "03:30", "04:00", "04:30", "05:00", "05:30",
        "06:00", "06:30", "07:00", "07:30", "08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
        "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
        "18:00", "18:30", "19:00", "19:30", "20:00", "20:30", "21:00", "21:30", "22:00", "22:30", "23:00"
    ],
    "days": [{
        id: "monday",
    }, {
        id: "tuesday",
    }, {
        id: "wednesday",
    }, {
        id: "thursday",
    }, {
        id: "friday",
    }, {
        id: "saturday",
    }, {
        id: "sunday",
    }],
    frequency: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", 
        "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", 
        "51", "52", "53", "54", "55", "56", "57", "58", "59", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", "72", "73", "74", "75",
        "76", "77", "78", "79", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "100",
    ],
}